// extracted by mini-css-extract-plugin
module.exports =  {"full-catalog-container":"derPDKK","fullCatalogContainer":"derPDKK"};